import {CommonReducer, ReducerFromState} from '../../@types/reducers';

export default (state: ReducerFromState<CommonReducer>): boolean => !!state.common.client;
